<template>
  <div
    id="TermsConditionsComponent"
    class="mb-4"
  >
    <p>
      Please read our Terms and Conditions then
      sign your name in the
      box below if you agree to them
    </p>
    <p>You cannot continue until you have clicked the link</p>
    <v-btn
      color="primary"
      text
      link
      outlined
      :href="'/agency-file/terms-conditions'"
      target="_blank"
      @click="$emit('tcs-clicked')"
    >
      <v-icon>
        mdi-file-document
      </v-icon>Terms &amp; Conditions
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'TermsConditionsComponent',
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {
          tenant: {
            settings: {
              terms_conditions_url: ''
            }
          }
        }
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
    #TermsConditionsComponent {
        //
    }
</style>
